import { isEqual, parse } from 'date-fns/esm'

export function isInFirstNonArchivedDate(selectionStart?: Date, firstNonArchivedDay?: string) {
  if (firstNonArchivedDay && selectionStart) {
    const firstNonArchivedDayAsDate = parse(firstNonArchivedDay, 'yyyyMMdd', new Date())
    return isEqual(firstNonArchivedDayAsDate, selectionStart)
  }

  return false
}
